import React, { useEffect, useState } from "react";
import "./css/VideoPlayer.css";

const VideoPlayer = ({ onCancel }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const video = document.getElementById("demo-video");
    if (video) {
      video.play();
      setIsPlaying(true);

      const handleVideoEnd = () => {
        setIsPlaying(false);
        setCurrentTime(0); // Reset the stopping point
      };

      video.addEventListener("ended", handleVideoEnd);

      return () => {
        video.removeEventListener("ended", handleVideoEnd);
      };
    }
  }, []);

  const playVideo = () => {
    const video = document.getElementById("demo-video");
    if (video) {
      video.currentTime = currentTime; // Resume from the stopping point
      video.play();
      setIsPlaying(true);
    }
  };

  const stopVideo = () => {
    const video = document.getElementById("demo-video");
    if (video) {
      setCurrentTime(video.currentTime); // Save the stopping point
      video.pause();
      setIsPlaying(false);
    }
  };

  return (
    <div className="video-modal">
      <div className="video-container">
        <div className="video-header">
          <h3>KinShield™ AI Scam Protection Overview</h3>
          <button className="close-button" onClick={onCancel}>
            ×
          </button>
        </div>
        <video
          id="demo-video"
          controls
          onClick={(e) => e.preventDefault()} // Disable clicks on the video
        >
          <source src="/KinShield__Digital_Defense.mp4" type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
        <div
          className="video-controls"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <button
            style={{
              width: "30%",
              backgroundColor: isPlaying ? "gray" : "",
              pointerEvents: isPlaying ? "none" : "auto",
            }}
            onClick={playVideo}
          >
            Play
          </button>
          <button
            style={{
              width: "30%",
              backgroundColor: !isPlaying ? "gray" : "",
              pointerEvents: !isPlaying ? "none" : "auto",
            }}
            onClick={stopVideo}
          >
            Stop
          </button>
          <button style={{ width: "30%" }} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;
